import {Injectable} from '@angular/core';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {UmpirePage} from '@tisa-group/models';

@Injectable()
export class PageService implements CrudService<UmpirePage> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpirePage[]>> {
    return this.http
      .get<JsonApiResponse<UmpirePage[]>>(`/pages`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePage>> {
    return this.http
      .get(`/pages/${fetchIdentifier}`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  create(
    body: Partial<UmpirePage>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePage>> {
    return this.http
      .post<JsonApiResponse<UmpirePage>>('/pages', serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpirePage>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePage>> {
    return this.http
      .patch<JsonApiResponse<UmpirePage>>(`/pages/${body.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/pages/${id}`);
  }
}
